export default __webpack_public_path__ + "static/media/viaccess-orca_hover.5efff4a3.png";